module.exports = __webpack_public_path__ + "img/BryantHeights-5.845dcdbf.jpg";